interface ScenarioIntroProps {
  onContinue: () => void;
  onBack?: () => void;
}

export function ScenarioIntro({ onContinue, onBack }: ScenarioIntroProps) {
  return (
    <section className="bloom-questions-intro bloom-scenario-intro" aria-label="Uitleg situatie-vragen">
      <div className="bloom-questions-intro__card">
        <h2 className="bloom-questions-intro__title">Situatie-vragen</h2>

        <div className="bloom-questions-intro__body">
          <p>
            Je hebt de vragen afgerond. Nu volgen een aantal situaties, waarin jij kunt aangeven
            wat jij waarschijnlijk zou doen in die situatie.
          </p>
          <p>
            Je leest een situatie en kiest het antwoord dat het meest lijkt op wat jij zou doen.
            De antwoorden zijn anders dan bij de stellingen: je kiest steeds uit vijf opties die
            bij die situatie passen.
          </p>
          <p>Er zijn geen goede of foute antwoorden. Kies wat op dit moment het beste bij jou past.</p>
        </div>

        <div className="bloom-questions-intro__actions">
          {onBack ? (
            <button type="button" className="bloom-btn bloom-btn--ghost" onClick={onBack}>
              Terug
            </button>
          ) : (
            <span />
          )}
          <button
            type="button"
            className="bloom-btn bloom-btn--primary bloom-questions-intro__start"
            onClick={onContinue}
          >
            Verder
          </button>
        </div>
      </div>
    </section>
  );
}
